import { render, staticRenderFns } from "./hzCertificate.vue?vue&type=template&id=65dec1be&scoped=true"
import script from "./hzCertificate.vue?vue&type=script&lang=js"
export * from "./hzCertificate.vue?vue&type=script&lang=js"
import style0 from "./hzCertificate.vue?vue&type=style&index=0&id=65dec1be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dec1be",
  null
  
)

export default component.exports